// Order only. Do not modify the app icon, counter, colors, size, or offsets.
const header = document.querySelector('#header-component');
if (header && !header.dataset.yehaWishlistObserver) {
  header.dataset.yehaWishlistObserver = 'true';
  let frame = 0;
  function orderWishlist() {
    const actions = header.querySelector('header-actions');
    const heart = header.querySelector('svg.Vtl-WishlistHeader__HeartIconWrapper');
    const clickable = heart?.closest('a, button, [role="button"]');
    const cart = actions?.querySelector('[data-testid="cart-drawer-trigger"], .action__cart');
    if (!actions || !clickable || !cart) return;
    let cartItem = cart;
    while (cartItem.parentElement && cartItem.parentElement !== actions) cartItem = cartItem.parentElement;
    if (cartItem.parentElement !== actions) return;
    let wishlistItem = clickable;
    if (actions.contains(clickable)) {
      while (wishlistItem.parentElement && wishlistItem.parentElement !== actions) wishlistItem = wishlistItem.parentElement;
    }
    if (wishlistItem.contains(cartItem)) return;
    wishlistItem.dataset.yehaWishlistAction = 'true';
    if (wishlistItem.parentElement !== actions || wishlistItem.nextElementSibling !== cartItem) actions.insertBefore(wishlistItem, cartItem);
  }
  const observer = new MutationObserver(() => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(orderWishlist);
  });
  observer.observe(header, {childList: true, subtree: true});
  orderWishlist();
}
